import { Component, OnDestroy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';

@Component({
    selector: 'app-accessibility',
    templateUrl: './accessibility.component.html',
    styleUrl: './accessibility.component.scss',
    imports: [TranslateModule, SharedModule],
    standalone: true,
})
export class AccessibilityComponent implements OnDestroy {
    translate() {
        window.$wt?.etrans?.translate('#translate-content');
    }

    ngOnDestroy() {
        window.$wt?.etrans?.cancelTranslation();
    }
}
